<template>
  <div class="speaker">
    <div class="speaker-grid">
      <img v-if="photo" :src="photo" class="speaker__avatar" :alt="name"/>
      <div v-else class="speaker__avatar">
        <c-avatar-plug
          letterSize="90px"
          width="140"
          height="140"
          :letter="name[0]"
        />
      </div>
      <h3 v-if="name" class="speaker__name">{{ name }}</h3>
    </div>
    <div class="speaker-grid">
      <div></div>
      <div v-if="title" class="speaker__title">{{ title }}</div>
    </div>


    <div>

      <div v-if="description" class="speaker__description" v-html="description"></div>
    </div>

    <div v-if="sessions?.length" class="speaker-sessions">
      <h5 class="speaker-sessions__title">Sessions</h5>
      <ul class="speaker-sessions__list">
        <li
          v-for="(session, index) in sessions"
          class="speaker-sessions__item"
          :key="`session-${index}`"
        >
          <a href="#" @click.prevent="goToSession(session.id)">{{ session.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ColoredStatus from "../../../components/ui/ColoredStatus";

export default {
  components: {
    ColoredStatus
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    photo: {
      type: String,
      default: ""
    },
    sessions: {
      type: Array,
      default: () => []
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
    }
  },
  methods: {
    goToSession(sessionId) {
      if (this.isModal) {
        if (+this.$route.params.sessionId === +sessionId) {
          this.$emit("closeModal");
        } else {
          this.$router.push({name: "Session Details", params: {sessionId: sessionId}, query: {back: this.$route.name}});
        }
      } else {
        this.$router.push({name: "Speakers Session Details", params: {sessionId: sessionId}, query: {back: 'Speakers'}});
      }
    }
  }
};
</script>

<style lang="scss" scoped>



.speaker {
  box-shadow: var(--attendee-box-shadow);
  padding: var(--attendee-gap-md);
  background-color: var(--attendee-card-color);
  border-radius: var(--attendee-card-border-radius);
  position: relative;
  --avatar-size: 140px;
  margin-top: 100px;
  //clear: both;





  .speaker-grid {
    grid-gap: var(--attendee-gap-md);
    display: grid;
    grid-template-columns: var(--avatar-size) 1fr;
    align-items: flex-end;
  }

  &__avatar {
    width: var(--avatar-size);
    height: var(--avatar-size);
    object-fit: cover;
    margin-top: calc(var(--avatar-size) * -1 / 2 - var(--attendee-gap-md));
    border-radius: 50%;

    //@media (max-width: 900px) {
    //  margin-top: 0;
    //  margin-bottom: 5px;
    //}
  }

  &__title {
    margin-bottom: var(--attendee-gap-lg);
    font-weight: 400;
    color: var(--attendee-text-secondary-color);
    font-size: 14px;


    @media (max-width: 900px) {
      margin-bottom: var(--attendee-gap-sm);
    }
  }

  &__name {
    font-size: 26px;
    color: var(--attendee-text-primary-color);

    @media (max-width: 900px) {
      font-size: 18px;
    }
  }

  &__description {
    margin-bottom: var(--attendee-gap-lg);
    color: var(--attendee-text-primary-color);

    * {
      color: var(--attendee-text-primary-color);
    }
  }
}

.speaker-sessions {
  clear: both;

  &__title {
    margin-bottom: var(--attendee-gap-md);
    font-size: 21px;
    font-weight: 600;
  }

  &__item {
    color: var(--attendee-brand-color);
    cursor: pointer;
    margin-bottom: var(--attendee-gap-sm);
    list-style: disc;
    margin-left: 15px;
  }
}
</style>
